// extracted by mini-css-extract-plugin
module.exports = {"box":"films_box__1ur4C","model":"films_model__2rMJS","back":"films_back__2HfWu","mainPageContainer":"films_mainPageContainer__2QhYY"};